import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthenticationForm from './components/AuthenticationForm';
import TestCredentials from './components/TestCredentials';
import SecurityBadges from './components/SecurityBadges';
import logo from "../../../public/assets/images/icon.png"; // Adjust the path as necessary
const WhatsAppAuthentication = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Check if user is already authenticated
    const user = localStorage.getItem('user');
    const token = sessionStorage.getItem('token');
    if (user) {
      const userData = JSON.parse(user);
      if (userData.role == 'admin' && token) {
        navigate('/admin-dashboard');
      } else if (userData.role == 'vendor' && token) {
        navigate('/vendor-dashboard');
      }  else if(!token){
        navigate('/whats-app-authentication');
      }
    }
  }, [navigate]);

  return (
    <div className="min-h-screen bg-background">
      {/* Main Content */}
      <div className="flex flex-col items-center justify-center min-h-screen px-4 py-8">
        <div className="w-full max-w-6xl mx-auto">
          {/* Header Section */}
          <div className="text-center mb-12">
            <div className="flex items-center justify-center space-x-3 mb-6">
              <div className="w-12 h-12 bg-primary rounded-xl flex items-center justify-center">
                <img src={logo} alt="logo" />
                
                {/* <svg
                  viewBox="0 0 24 24"
                  className="w-7 h-7 text-white"
                  fill="currentColor"
                >
                  <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 3c1.93 0 3.5 1.57 3.5 3.5S13.93 13 12 13s-3.5-1.57-3.5-3.5S10.07 6 12 6zm7 13H5v-.23c0-.62.28-1.2.76-1.58C7.47 15.82 9.64 15 12 15s4.53.82 6.24 2.19c.48.38.76.97.76 1.58V19z"/>
                </svg> */}
              </div>
              <div>
                <h1 className="text-3xl font-bold text-foreground">Workly</h1>
                <p className="text-sm text-muted-foreground">Admin Management Platform</p>
              </div>
            </div>
            
            {/* <div className="max-w-2xl mx-auto">
              <h2 className="text-xl font-semibold text-foreground mb-3">
                Secure Business Authentication
              </h2>
              <p className="text-muted-foreground">
                Access your vendor management dashboard with WhatsApp-based two-factor authentication. 
                Streamline your business operations with role-based access control for administrators, 
                vendors
              </p>
            </div> */}
          </div>

          {/* Authentication Form */}
          <div className="flex justify-center mb-8">
            <AuthenticationForm />
          </div>

          {/* Test Credentials */}
          {/* <div className="flex justify-center mb-12">
            <TestCredentials />
          </div> */}

          {/* Security Badges */}
          <SecurityBadges />

          {/* Footer */}
          <div className="mt-16 text-center">
            <div className="border-t border-border pt-8">
              <p className="text-xs text-muted-foreground mb-4">
                Trusted by businesses worldwide for secure vendor management
              </p>
              <div className="flex items-center justify-center space-x-6 text-xs text-muted-foreground">
                <span>© {new Date().getFullYear()} Workly</span>
                <span>•</span>
                <span>Privacy Policy</span>
                <span>•</span>
                <span>Terms of Service</span>
                <span>•</span>
                <span>Support</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhatsAppAuthentication;